import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../../lib/utils';

const PartnersCTA = () => {
  const navigate = useNavigate();

  const handleContact = () => {
    navigate('/about');
    setTimeout(() => {
      const contactSection = document.querySelector('#contact-form');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  return (
    <section className="py-24 bg-black relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/95 to-black/90" />
        <div className="absolute inset-0 opacity-30">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_#1EB899_0%,_transparent_50%)]" />
        </div>
      </div>

      <div className="container mx-auto px-4 relative">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex items-center justify-center gap-3 mb-6"
          >
            <Mail className="w-6 h-6 text-accent" />
            <span className="text-accent">Ready to Collaborate?</span>
          </motion.div>
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-4xl md:text-5xl font-display font-semibold text-white mb-6"
          >
            We're Ready for What's Next.<br />
            Let's Build It Together.
          </motion.h2>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-xl text-gray-300 mb-12"
          >
            Interested in collaborating or learning more about our partnerships? 
            Get in touch and discover how we can work together to achieve extraordinary results.
          </motion.p>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <button
              onClick={handleContact}
              className={cn(
                "group inline-flex items-center gap-2 px-8 py-4 bg-accent rounded-lg text-white font-medium",
                "hover:bg-accent/90 transition-all duration-300"
              )}
            >
              <span>Get in Touch</span>
              <ArrowRight className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300" />
            </button>
            
            <a
              href="mailto:info@solutions21.ae"
              className={cn(
                "group inline-flex items-center gap-2 px-8 py-4 border-2 border-white/20 rounded-lg text-white font-medium",
                "hover:border-accent hover:bg-accent/10 transition-all duration-300"
              )}
            >
              <Mail className="w-5 h-5" />
              <span>info@solutions21.ae</span>
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="mt-12 pt-8 border-t border-white/10"
          >
            <p className="text-gray-400 text-sm">
              Join us in shaping the future of digital transformation through strategic partnerships.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PartnersCTA;